<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="12" sm="12">
          <!-- <div class="center-name">Enter New Center Name</div> -->
        </v-col>
        <v-col cols="4" sm="4" class="zero-top">
          <div class="show-drop-down">
            <div class="label-data">Select Center(s)</div>
            <div class="field-data">
              <multi-select
                allText="All Centers"
                :items="centers"
                ref="centerDD"
                label="select center"
                :onChange="onCenterchange"
                widthcss="fix-width-200"
              ></multi-select>
            </div>
          </div>
        </v-col>
        <v-col cols="4" sm="4" class="zero-top">
          <div class="show-drop-down">
            <div class="label-data">Select Batch(es)</div>
            <div class="field-data">
              <multi-select
                allText="All Batches"
                :items="batches"
                ref="batchDD"
                label="select batch"
                :onChange="onBatchSelect"
                widthcss="fix-width-200"
              ></multi-select>
            </div>
          </div>
        </v-col>
        <v-col cols="4" sm="4" class="zero-top">
          <div class="show-drop-down">
            <div class="field-data">
              <v-text-field
                hide-details="auto"
                v-model="search_query"
                label="Name/Email ID"
                dense
                outlined
                append-icon="search"
              >
              </v-text-field>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="zero-top">
          <v-data-table
            :headers="headers"
            :items="items"
            hide-default-header
            hide-default-footer
            class="batch-elevation"
          >
            <template v-slot:header="{ props: { headers } }">
              <TableHeader
                :headers="headers"
                :orderBy="orderBy"
                :onSortChange="onSortChange"
              />
            </template>
            <template v-slot:item.left_time="{ item }">
              {{ parseTime(item.left_time) }}
            </template>
           
          </v-data-table>
        </v-col>
      </v-row>
    </div>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
export default {
  name: "LiveTracking",
  props: ["onClose", "status", "data"],
  data() {
    return {
      loading: false,
      orderBy: {
        field: "name",
        order: "ASC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      centers: [],
      batches: [],
      items: [],
      search_query: "",
      selectedCenter: [],
      selectedBatches: [],
      timerID: null,
      headers: [
        {
          text: "Student Name",
          align: "center",
          class: "text-center",
          sortable: true,
          value: "name",
        },
        {
          text: "Email ID",
          align: "center",
          class: "text-center",
          sortable: true,
          value: "email",
        },
        {
          text: "Start Time",
          align: "center",
          class: "text-center",
          sortable: true,
          value: "start_time",
        },
        {
          text: "Time Left",
          align: "center",
          class: "text-center",
          sortable: true,
          value: "left_time",
        },
        {
          text: "Phone",
          align: "center",
          class: "text-center",
          sortable: true,
          value: "phone",
        },
      ],
    };
  },
 
  watch: {
    status(val) {
      this.resetPage();
      this.requestGetCenters(this.selectedCenter);
      if(this.status){
        this.getLiveTestStudents();
      }
      if (val) {
        this.timerChange();
      }
      else {
        let me = this;
        clearInterval(me.timerID);
      }

    },
    search_query() {
      this.getLiveTestStudents();
    },
   
  },
  mounted() {
    this.resetPage();
    this.requestGetCenters(this.selectedCenter);
    this.getLiveTestStudents();
    this.timerChange();
  },
  
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getLiveStudents: "testStore/getLiveStudents",
      getBatches: "centerAndBatchStore/getBatches",
    }),
    getCentersFunction() {
      if (this.isCoordinator()) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    isCoordinator() {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user && user.role_id === constants.ROLES_ID.CO) {
        return true;
      }
      return false;
    },
    onBatchSelect(selectedBatch) {
      this.selectedBatches = selectedBatch;
      this.getLiveTestStudents();
    },
    pad(num) {
      return ("0" + num).slice(-2);
    },
    parseTime(secs) {
      var minutes = Math.floor(secs / 60);
      secs = Math.floor(secs % 60);
      var hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      
      return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
      // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
    },
    
    requestGetCenters(alreadySelectedCenter) {
      this.centers = [];
      this.$root.showLoader = true;
      this[this.getCentersFunction()]()
        .then((response) => {
          this.$root.showLoader = false;
          this.allCenters = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
          this.centers = this.allCenters.filter((c) => {
            return alreadySelectedCenter.indexOf(c.value) === -1;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    //   this.getCenters({ orderBy: this.orderByForCenter })
    //     .then((response) => {
    //       this.loading = false;
    //       this.centers = response.map((x) => {
    //         let c = {};
    //         c.text = x.name;
    //         c.value = x.id;
    //         return c;
    //       });
    //       this.centers = this.centers.filter((c) => {
    //         return alreadySelectedCenter.indexOf(c.value) === -1;
    //       });
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //     });
    // },
    onSortChange() {
      this.getLiveTestStudents();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.getLiveTestStudents();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.getLiveTestStudents();
    },
    getLiveTestStudents() {
      let reqData = {
        schedule_id: this.data.selectedTest.schedule_id,
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      if (this.search_query.trim() !== "") {
        reqData.search_query = this.search_query;
      }
      if (this.selectedBatches.length) {
        reqData.batch_ids = this.selectedBatches;
      } else if (this.selectedCenter.length) {
        reqData.center_ids = this.selectedCenter;
      }

      this.getLiveStudents(reqData)
        .then((response) => {
          this.items = response.list;
          this.totalPages = response.pagination.pageCount;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    onCenterchange(centerIds) {
      this.selectedCenter = centerIds;
      this.getLiveTestStudents();

      this.batches = [];
      if (this.selectedCenter.length)
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            this.loading = false;
            this.batches = response.list.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              return c;
            });
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
    },
    resetPage() {
      this.selectedCenter = [];
      this.selectedBatches = [];
      this.$refs.batchDD.clearAllSelection();
      this.$refs.centerDD.clearAllSelection();
      this.batches = [];
      this.search_query = "";
    },
     timerChange() {
      let me = this;
      this.timerID = setInterval(function() {
      me.getLiveTestStudents();
      },60 * 1000); 
    },
  },
  
 
};
</script>
